<app-header *ngIf="isLoggedIn" [@headerAnim]></app-header>
<router-outlet></router-outlet>
